import { useEstablishmentLead } from "@/features/establishmentLeadsFunnel/hooks/useEstablishmentLead"
import { useParams } from "react-router-dom"
import Form from "./form"

const Update = () => {
  const { id, establishmentLeadId } = useParams()
  const { data: establishmentLead, isPending: isLoadingEstablishmentLead } = useEstablishmentLead(establishmentLeadId || '')

  return (
    <>
      {(!isLoadingEstablishmentLead && !!establishmentLead) && (
        <Form 
          contact={establishmentLead.contacts?.find((contact) => contact.id === id)}
          establishmentLeadState={establishmentLead.state}
          establishmentRestContacts={establishmentLead?.contacts?.filter((contact) => contact.id !== id) || []}
          establishmentLeadName={establishmentLead?.display_name}
          establishmentLeadImageUrl={establishmentLead?.general_information?.company_logo?.url}
        />
      )}
    </>
  )
}

export default Update